import { Button, Textarea } from 'design-system';
import { ArrowRight } from 'lucide-react';

import { useMessageInput } from './useMessageInput';

const MessageInput = ({ maxRows }: { maxRows: number }) => {
  const { inputMessage, isDisabled, handleSend, handleChange, handleKeyDown } = useMessageInput();

  return (
    <div className='shrink-0 border-t border-[#26272f] bg-[#0a0a0f] px-4 py-3'>
      <div className='flex items-stretch gap-2'>
        <div className='min-w-0 flex-1 rounded-[3px] border border-[#3d3f4c] bg-[#17181f] transition-colors focus-within:border-[#8c7cf0]'>
          <Textarea
            aria-label='Enter your prompt'
            className='min-h-10 resize-none border-0 bg-transparent px-3 py-2 text-sm leading-6 text-[#f3f2ed] placeholder:text-[#66677a] focus-visible:ring-0 dark:bg-transparent'
            placeholder='Ask about your markets...'
            rows={1}
            style={{ maxHeight: `${maxRows * 24 + 8}px` }}
            value={inputMessage}
            onChange={e => {
              handleChange(e.target.value);
            }}
            onKeyDown={handleKeyDown}
          />
        </div>
        <Button
          aria-label='Send prompt'
          className='h-auto min-h-10 w-10 shrink-0 rounded-[3px] bg-[#8c7cf0] text-[#0b0820] hover:bg-[#9e8ff5] disabled:bg-[#8c7cf0] disabled:text-[#0b0820] disabled:opacity-100'
          disabled={isDisabled || !inputMessage.trim()}
          size='icon-lg'
          onClick={handleSend}
        >
          <ArrowRight className='size-4' />
        </Button>
      </div>
    </div>
  );
};

export default MessageInput;
